import Factory from '../factory';

const schema = Factory.schema('search-content-advanced');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('Search');
attributes.prop('contentType').setType(String).setValue(null);

export default schema;
